<template>
  <div class="divider" />
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.divider {
  width: vw(1820px);
  height: vh(1px);
  margin: 0 auto;
  background-color: $text-paragraph-color;
  opacity: 0.6;
}
</style>
